module.exports = __webpack_public_path__ + "img/餐饮icon5.54acce44.png";